import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DynamicDataRequestConfig} from '../model/dynamicData/dynamicDataRequestConfig';
import * as moment from 'moment';

@Component({
    selector:'dynamicDataFilter',
    template:`
        <div [style.display]="hide ? 'none' : 'inline'" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <img alt="icon" class="explorerWindow" src="../../assets/images/filter-icon.png">
                        <h4 class="modal-title">Dynamic Data Filter</h4>
                        <h4 class="closeBtnH4"><button (click)="toggleFilter();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                            <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                        </button></h4>
                    </div>
                    <div class="modalBodyContainer">
                        <form [formGroup]="myForm">
                            <div class="modal-body col-md-12">
                              <div class="bodyContent">
                                        <div class="tagsbox row top-buffer col-md-6">
                                            <h3 style="margin-left:5px;margin-top:10px;float:left;" *ngFor="let tag of filterString"><span class="badge badge-secondary">{{tag}}<span style="margin-left: 5px;" (click)="removeFilterString(tag)"><i style="color: red; font-size: 20px;" class="far fa-times-circle"></i></span></span></h3>
                                        </div>
                                        <div  class="col-md-6 input-group mb-4" style="float:left;margin-top:10px;">
                                            <input type="text" class="form-control" aria-label="filterSpring" aria-describedby="button-addon2" formControlName="filterTags">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" (click)="addTag()">Add Tag</button>
                                            </div>
                                        </div>
                                    <div style="border: #00b0ff;border-width: medium;border-style: solid;margin-top: 90px;">
                                        <label>Date Constraints</label>
                                        <table>
                                            <tr>
                                                <td><label>Start Date</label></td>
                                                <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="startDateChanged($event)"></ejs-datepicker></td>
                                            </tr>
                                            <tr>
                                                <td><label>End Date</label></td>
                                                <td><ejs-datepicker id='datepicker' placeholder='Select a date' [value]='dateValue' [min]='minDate' [max]='maxDate' (change)="endDateChanged($event)"></ejs-datepicker></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="modal-footer ">
                                        <button class="btn btn-primary" (click)="applyConfig()">Apply</button>
                                    </div>
                              </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    `,
    styles:[`
        .modal-header{
            background-color:dodgerblue;
            color:antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }
        .modal-content{
            border-top-right-radius: 18px;
            border-top-left-radius: 18px;
        }
        .closeX{color:azure;size:25px;}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}

        /* new css*/

        .formCheckbox{margin-right: 5px;}

        .explorerWindow{height:32px;}

        .modal-title{margin-top: -5px;}
        .closeBtnH4{margin-top:-5px;margin-right: -8px;}
        .appWindow {
            height: 35px;
        }
        .clientRow{background-color: #D0DFFE;}

        .led{width:22px;}

        .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
        th{color:#ffffff;text-align: center;}

        .tagsbox{border-width: 1px;border-color: #1c71ff;border-style: dashed;margin-left: 15px;width: 300px;height:50px;}
        .modalBodyContainer{
          background-color:  #ECE8E5;
        }

        .modal-footer{background-color: #ECE8E5;border-top: groove;}
        .modal-body {
            width: 100%;
            padding-left: 10px;
            padding-right: 10px;
        }
        .modal-body thead {
            position: sticky;
            top:0;
        }
        ::-webkit-scrollbar {
            width: 14px;
            height: 5px;
            background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
            height: 6px;
            border: 4px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            -webkit-border-radius: 7px;
            background-color:#BACEFF;
            -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
            width: 14px;
            height: 14px;
            display: none;
        }
        ::-webkit-scrollbar-corner {
            background-color: transparent;
        }

        .modal-dialog {
          width: 50%;
          margin:  auto;
        }
        .modal-header{
          height:56px;
          background-image: url("../../assets/images/headerBack.jpg");
          color:  #ECE8E5;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }
        .modal-content{
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
          padding-left: 3px;
          padding-right: 3px;
          background-color: #0064FE;
          padding-bottom: 3px;
        }

        .closeX {
            color: white;
            size: 25px;
        }

        .btn-outline-danger {
            background-color: #d6462e;
            border-style: solid;
            border-color: white;
            border-width: 2px;
            padding: 0;
        }

        /* .btn-outline-danger:hover {
             width: 32px;
             background-image: url("../../../assets/images/closeBtnHovered.png");
         }*/

        .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}`]
})

export class DynamicDataFilterComponent implements OnInit {

    @Input() dynamicDataRequestConfig: DynamicDataRequestConfig;
    @Output() refreshDynamicData:EventEmitter<any> = new EventEmitter();
    private hide = true;
    private filterString: string[] = [];
    private myForm: FormGroup;

    private minDate: Date = new Date ('01/01/1979');
    private maxDate: Date = new Date ('01/01/2100');
    private dateValue: Date = new Date (Date());

    toggleFilter() {
        this.hide = !this.hide;
    }


    removeFilterString(tag: string) {
        const index = this.filterString.indexOf(tag);
        this.filterString.splice(index,1);
    }

    ngOnInit(): void {
        this.myForm = new FormGroup({
            filterTags: new FormControl()
        });
    }

    addTag() {
        console.log(this.myForm['controls'].filterTags.value);
        this.filterString.push(this.myForm['controls'].filterTags.value);
    }

    startDateChanged($event:any) {
        // console.log($event.value.toString());
        const dateString = moment($event.value.toISOString()).format();
        // this.startDate = $event.value.getTime().toString();
        this.dynamicDataRequestConfig.dynamic_values_filter.min_date = dateString;
    }

    endDateChanged($event:any) {
        console.log($event);
        // this.endDate = $event.value.getTime().toString();
        const dateString = moment($event.value.toISOString()).format();
        this.dynamicDataRequestConfig.dynamic_values_filter.max_date = dateString;
    }

    applyConfig() {
        for(const str of this.filterString) {
            this.dynamicDataRequestConfig.dynamic_values_filter.keys_filter.push(str);
        }

        this.refreshDynamicData.emit(this.dynamicDataRequestConfig);
    }
}
